import { mfestsApi } from "api/mfests_api";

export const getSearch = async ({ query }) => {
  const data = await mfestsApi.get({ query: query, url: `search?q=${query}` });
  return data;
};
